import { render, staticRenderFns } from "./DefaultLayoutEn.vue?vue&type=template&id=4ddbfb4c&scoped=true&"
import script from "./DefaultLayoutEn.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutEn.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayout.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./DefaultLayoutEn.vue?vue&type=style&index=1&id=4ddbfb4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddbfb4c",
  null
  
)

export default component.exports